import { render } from "./ShowWhatsapp.vue?vue&type=template&id=71a148e6&scoped=true"
import script from "./ShowWhatsapp.vue?vue&type=script&lang=js"
export * from "./ShowWhatsapp.vue?vue&type=script&lang=js"

import "./ShowWhatsapp.vue?vue&type=style&index=0&id=71a148e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a148e6"]])

export default __exports__